
import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import Awbcards from'../../components/AWBDashboard/AWBdashboard';
const defaultTheme = createTheme();
const AWBDashboard = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
      <Awbcards />
    </ThemeProvider>
  )
}

export default AWBDashboard